<template>
  <div>
    <div v-if="header" class="hot-destinations--header">
      <div
        @click="emitBack"
        class="hot-destinations--back pointer"
        data-testid="hot-destinations--back pointer"
      >
        <i class="icon-arrow-left xxs"></i>
      </div>
      <div class="hot-destinations--title">{{ name }}</div>
    </div>

    <div class="grid" :style="`grid-template-columns: repeat(${cardsPerRow}, 1fr ) `">
      <HotDestinationsCityCard
        :style="`grid-column:${calculateColumn(idx)}`"
        v-for="({ name, hotels, priceFrom, state, image }, idx) in citiesGrid"
        :key="name"
        :name="name"
        :numHotels="hotels ? hotels.length : 0"
        :priceFrom="priceFrom"
        :state="state"
        :image="image"
        @click-card="handleHotDestinationsCardClick(idx)"
      />
      <div
        :class="[
          'test',
          showHotelsGrid || (cities.length === 1 && showHotelsGrid) ? 'block' : 'none'
        ]"
        :style="`grid-area:${calculateGridArea}`"
        data-testid="show-hotel-grid"
      >
        <HotelGrid :hotels="hotels" />
      </div>
    </div>
  </div>
</template>

<script>
import HotDestinationsCityCard from './HotDestinationsCityCard.vue'
import HotelGrid from './HotelGrid.vue'
import { media } from '@/infrastructure/Utils'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('offersDestinations')

export default {
  name: 'HotDestinations',
  components: {
    HotDestinationsCityCard,
    HotelGrid
  },
  props: {
    cities: {
      type: Array,
      required: true
    },
    header: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    activeTab: {
      type: String,
      default: 'hotDestinations'
    }
  },
  watch: {
    cities(newValue) {
      if (this.selectedCode) {
        const [{ code }] = this.filteredDestinations
        this.citiesGrid = newValue.map(city => {
          if (city.code === code && !this.checkSoldOut()) {
            return { ...city, state: 'selected-card' }
          } else if (city.code === code && this.checkSoldOut()) {
            return { ...city, state: 'active' }
          } else {
            return { ...city, state: 'disabled-card' }
          }
        })
        this.hotels = this.citiesGrid[this.selectedIndex].hotels
      } else {
        this.citiesGrid = newValue.map(city => ({
          ...city,
          state: this.citiesGrid.find(cityOld => cityOld.code === city.code).state
        }))
        this.hotels = this.citiesGrid[this.selectedIndex].hotels
      }
    },
    showHotelsGrid(newValue) {
      if (!newValue) {
        this.setFilteredDestinationStateActive()
      }
    }
  },
  data() {
    return {
      showHotelsGrid: false,
      selectedIndex: 0,
      hotels: [],
      citiesGrid: [],
      cardsPerRow: 0
    }
  },
  methods: {
    emitBack() {
      this.$emit('go-back')
    },
    handleHotDestinationsCardClick(idx) {
      if (this.isLoading) {
        this.showHotelsGrid = false
        return
      }
      const state = this.citiesGrid[idx].state
      this.selectedIndex = idx

      if (state === 'active' || state === 'disabled-card') {
        this.showHotelsGridComponent()
      } else {
        this.hideHotelsGridComponent()
      }
    },
    showHotelsGridComponent() {
      this.hotels = this.citiesGrid[this.selectedIndex].hotels
      if (this.checkSoldOut()) {
        this.hotels = []
      }
      this.citiesGrid.forEach(
        (elem, index) =>
          (elem.state = index !== this.selectedIndex ? 'disabled-card' : 'selected-card')
      )
      this.showHotelsGrid = true
    },
    hideHotelsGridComponent() {
      this.citiesGrid = this.setCitiesState(this.citiesGrid)
      this.showHotelsGrid = false
    },
    calculateBreakpoint() {
      if (innerWidth < 768) {
        this.cardsPerRow = 1
      } else if (innerWidth > 768 && innerWidth < media('tablet-l')) {
        this.cardsPerRow = 2
      } else if (innerWidth > media('tablet-l') && innerWidth < 1200) {
        this.cardsPerRow = 3
      } else {
        this.cardsPerRow = 4
      }
    },
    calculateGridAreaRow() {
      return Math.ceil((this.selectedIndex + 1) / this.cardsPerRow) + 1
    },
    calculateColumn(idx) {
      return (idx % this.cardsPerRow) + 1
    },
    checkSoldOut() {
      return this.citiesGrid[this.selectedIndex]
        ? this.citiesGrid[this.selectedIndex].hotels.every(hotel => hotel.priceFrom?.amount === 0)
        : this.hotels.every(hotel => hotel.priceFrom?.amount === 0)
    },
    openHotelgridSelectedDestination(cities) {
      if (this.selectedCode && this.activeTab === 'allDestinations') {
        const [{ code }] = this.filteredDestinations
        for (let i = 0; i < cities.length; i++) {
          const city = cities[i]
          if (city.code === code && !this.checkSoldOut()) {
            this.selectedIndex = i
            this.showHotelsGridComponent()
          }
        }
      }
    },
    setCitiesState(cities) {
      if (this.selectedCode && this.activeTab === 'allDestinations') {
        const [{ code }] = this.filteredDestinations
        return cities.map(city => {
          if (city.code === code) {
            return { ...city, state: 'active' }
          } else {
            return { ...city, state: 'disabled-card' }
          }
        })
      } else {
        return this.cities.map(city => ({ ...city, state: 'active' }))
      }
    },
    setFilteredDestinationStateActive() {
      this.selectedIndex = 0
      if (this.citiesGrid[0] && !this.checkSoldOut() && this.activeTab === 'allDestinations') {
        this.citiesGrid[0].state = 'active'
      }
    }

  },
  computed: {
    ...mapGetters(['selectedCode', 'filteredDestinations']),
    calculateGridArea() {
      return `${this.calculateGridAreaRow()} / 1 / ${this.calculateGridAreaRow()} / ${this
        .cardsPerRow + 1}`
    },
    isLoading() {
      return !('priceFrom' in this.citiesGrid[0])
    }
  },
  created() {
    this.calculateBreakpoint()

    window.onresize = () => {
      this.calculateBreakpoint()
    }
  },
  mounted() {
    this.citiesGrid = this.setCitiesState(this.cities)
    this.openHotelgridSelectedDestination(this.citiesGrid)
  }
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-gap: 1.25rem;
}

.test {
  width: 100%;
}

.block {
  display: block;
}
.none {
  display: none;
}

.hot-destinations {
  &--header {
    display: flex;
    margin-top: 2rem;
    margin-bottom: 2rem;
    align-items: center;
  }
  &--title {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.138462px;
    color: var(--color-eclipse);
  }
  &--back {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid black;
    width: 2.125rem;
    height: 2.125rem;
    margin-right: 1.5rem;
  }
}

.pointer {
  cursor: pointer;
}
</style>
